import * as React from "react"

import FooterBottomSection from "./footer-bottom-section"
import FooterMainSection from "./footer-main-section"

type FooterProps = {
  footerCardContent?: React.ReactNode
}

const Footer = ({ footerCardContent }: FooterProps) => {
  return (
    <footer>
      {footerCardContent}
      <FooterMainSection />
      <FooterBottomSection />
    </footer>
  )
}

export default Footer
